module.exports = __webpack_public_path__ + "img/celeris-logo.0201f26f.svg";